export const getViewingCompanyName = (profile, selectedCompanyId) => {
  const memberships = profile && Array.isArray(profile.user_company_users)
    ? profile.user_company_users
    : [];

  if (memberships.length === 0) {
    return null;
  }

  const normalizedCompanyId = Number(selectedCompanyId);
  const selectedMembership = selectedCompanyId
    ? memberships.find((item) => item.company === normalizedCompanyId)
    : null;

  return (selectedMembership || memberships[0]).company_name || null;
};

export const canViewImpersonatedCalendar = (
  profile,
  isImpersonating,
  permissions,
) => Boolean(
  profile
  && isImpersonating
  && Array.isArray(permissions)
  && ["view_work_order", "view_inspection", "view_periodic"].some(
    (permission) => permissions.includes(permission),
  )
);
